import { render, staticRenderFns } from "./AccountingSuperPDP.vue?vue&type=template&id=28262dbe&"
import script from "./AccountingSuperPDP.vue?vue&type=script&lang=js&"
export * from "./AccountingSuperPDP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports